import { getConfig } from '@edx/frontend-platform';
import { useIntl } from '@edx/frontend-platform/i18n';
import { Link } from 'react-router-dom';

import messages from './messages';

const EmailRetryIssueNotice = () => {
  const { formatMessage } = useIntl();

  return (
    <p className="small-text mb-0">
      {formatMessage(messages['max.email.failed.attempts.text'], { 
        spam: <span style={{ fontWeight: 700 }}>{formatMessage(messages['max.email.failed.attempts.spam.folder'])}</span>,
        enter: <br />,
        support: <Link to={getConfig()?.WP_DOMAIN ? `${getConfig().WP_DOMAIN}/contact-us` : `mailto:${getConfig().INFO_EMAIL}`} target="_blank" className="link-style dark-green-color">{formatMessage(messages['max.email.failed.attempts.technical.support.link'])}</Link>
      })}
    </p>
  );
};

export default EmailRetryIssueNotice;
